export type WithLocalPetitionPhoto = Readonly<{
	photo: Readonly<{ petitionMedium: Readonly<{ processing: boolean; url: string }> }> | null;
}>;

/**
 * The image a local section card shows, or undefined when it has none to show.
 *
 * A photo that is still processing has a URL that doesn't resolve yet, so it counts as no
 * image - the card renders its own placeholder rather than a broken image.
 */
export function getLocalPetitionCardImageUrl({ photo }: WithLocalPetitionPhoto): string | undefined {
	if (!photo || photo.petitionMedium.processing) return undefined;

	return photo.petitionMedium.url;
}
